/**
 * background CSS 문자열(단색 또는 그라디언트)에서 첫 번째 색상을 추출해
 * 밝은 배경인지 판별한다. 색상을 파싱할 수 없으면 false(다크 배경 취급)를 반환.
 */
export const isLightBackground = (background?: string): boolean => {
  if (!background) return false

  let r: number
  let g: number
  let b: number

  const hexMatch = background.match(/#([0-9a-fA-F]{3,8})/)
  const rgbMatch = background.match(/rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)/)

  if (hexMatch) {
    let hex = hexMatch[1]
    if (hex.length === 3 || hex.length === 4) {
      hex = hex
        .split('')
        .map((c) => c + c)
        .join('')
    }
    r = parseInt(hex.slice(0, 2), 16)
    g = parseInt(hex.slice(2, 4), 16)
    b = parseInt(hex.slice(4, 6), 16)
  } else if (rgbMatch) {
    r = Number(rgbMatch[1])
    g = Number(rgbMatch[2])
    b = Number(rgbMatch[3])
  } else {
    return false
  }

  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255
  return luminance > 0.6
}
